<template>
	<div class="grid grid-cols-1 xl:grid-cols-2 gap-3">
		<PaymentLinkComponent
			v-for="accountLevel in AccountLevel"
			:key="`payment-links-${type}-${accountLevel}-${links.length}`"
			:event-id="eventId"
			:link="getPaymentLink(accountLevel)"
			:type="type"
			:account-level="accountLevel"
			@stored="store"
			@destroyed="destroy"
		/>
	</div>
</template>
<script setup lang="ts">
import {ref, type Ref, defineProps} from 'vue'
import {AccountLevel} from '@/Types/Enums/AccountLevel'
import {PaymentLinkType} from '@/Types/Enums/PaymentLinkType'
import {type PaymentLink} from '@/Types/Events/Payments/PaymentLink'
import PaymentLinkComponent from '@/Components/Events/Payments/PaymentLink.vue'

const props = defineProps<{
	eventId:number,
	type:PaymentLinkType,
	links:Array<PaymentLink>,
}>()

const links:Ref<Array<PaymentLink>> = ref(props.links)

function getPaymentLink(accountLevel:AccountLevel):PaymentLink|undefined{
	return links.value.find((p:PaymentLink) => p.account_level === accountLevel)
}

function store(newPaymentLink:PaymentLink):void{
	links.value.push(newPaymentLink)
}

function destroy(newPaymentLink:PaymentLink):void{
	const index = links.value.findIndex((p:PaymentLink) => p.id === newPaymentLink.id)
	if(index > -1){
		links.value.splice(index, 1)
	}
}
</script>